import React, { useEffect, useRef, useState } from "react";
import mammoth from "mammoth";
import { Box, Button, Input, LinearProgress, TextField } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { isEmpty, set } from "lodash";
import PlaygroundApp from "../../components/lexicalEditor/lexical-playground/src/App";
import TextEditorWithTitle from "../question/components/TextEditorWithTitle";
import { createMcqQuestion } from "../../services/question/mcq";
import { useParams } from "react-router-dom";
import QuestionViewPopup from "../questions/QuestionViewPopup";

function WordEditor() {
  const [htmlContent, setHtmlContent] = useState("");
  const [selectedText, setSelectedText] = useState("");
  const inputRef = useRef(null);

  const [coppiedQuestionContent, setCoppiedQuestionContent] = useState("")
  const [coppiedAnswerContent, setCoppiedAnswerContent] = useState([])

  const [answers, setAnswers] = useState([]);
  const [selectedInputIndex, setSelectedInputIndex] = useState(-1)

  const [loading, setLoading] = useState(false);
  
  const [questionEditorState, setQuestionEditorState] = useState({})
  const [answerEditorStates, setAnswerEditorStates] = useState([])
  const [quesiton, setQuesiton] = useState("");

  const [questionNumber, setQuestionNumber] = useState(1)
  const [questionNumberPrefix, setQuestionNumberPrefix] = useState("")

  const [questionView, setQuestionView] = useState({
    open: false,
    question: null,
  })

  const inputRefs = useRef([]);

  const {subjectId_} = useParams()

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey) {
        if (event.key === "s") {
          // event.preventDefault(); // prevent browser's default save dialog
          // console.log("Ctrl + S pressed");
        }
        if (event.key === "Enter") {
           event.preventDefault(); // prevent browser's default save dialog
          // console.log("Ctrl + Enter pressed");
        }
        if (event.key === "q") {
           event.preventDefault(); // prevent browser's default save dialog
          // console.log("Ctrl + q pressed");
          onSelectQuestion()
        }
        if (event.key === "e") {
           event.preventDefault(); // prevent browser's default save dialog
          // console.log("Ctrl + q pressed");
          onSelectAnswer()
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [answers, quesiton]);

  useEffect(() => {
    inputRefs.current = answers.map((_, i) => inputRefs.current[i] || React.createRef());
  }, [answers]);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.convertToHtml({ arrayBuffer });
    setHtmlContent(result.value);
  };

  const getSelectedText = () => {
    const selection = window.getSelection();
    const text = selection ? selection.toString() : "";
    // setSelectedText(text);
    // console.log(text)
    return text;

    // Optional: Paste directly into input box
    // if (inputRef.current) {
    //   inputRef.current.value = text;
    // }
    
  };

  const onSelectQuestion = () => {
    const selectedText = getSelectedText();
    setCoppiedQuestionContent(selectedText);
    setSelectedInputIndex(-1); // Reset selected input index
  }

  const onSelectAnswer = () => {
    const selectedText = getSelectedText();
    const index = answers.length;
    const scrollTop = answerContainerRef.current?.scrollTop;

    setSelectedInputIndex(index);
    setCoppiedAnswerContent([...coppiedAnswerContent, selectedText]);

    // Delay setting focus and restoring scroll after DOM update
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
      if (answerContainerRef.current) {
        answerContainerRef.current.scrollTop = scrollTop;
      }
    }, 0);
  }

  const onChangeHtml = (html, index) => {
    // console.log(html)
    if (index === -1) {
      setQuesiton(html);
    } else {
      const newAnswers = [...answers];
      newAnswers[index] = html;
      setAnswers(newAnswers);
    }
  };


  const handleChangeAnswerEditorState = (state, index) => {
    const newAnswerEditorStates = [...answerEditorStates];
    newAnswerEditorStates[index] = state;
    setAnswerEditorStates(newAnswerEditorStates);
    // console.log("answer editor state changed", newAnswerEditorStates)
  }

  const handleNamePrefixChange = (e) => {
    const str = e.target.value
    //check / is present in the string
    if (str.includes("/")) {
      alert("Question name prefix cannot contain '/' character");
      return;
    }
    setQuestionNumberPrefix(e.target.value);
  }

  const handleNumberChange = (e) => {
    const str = e.target.value
    // check is number
    if (isNaN(str)) {
      alert("Question number must be a number");
      return;
    }
    setQuestionNumber(str);
  }

  const handleDeleteAnswer = (index) => {
    const newAnswers = [...answers];
    newAnswers.splice(index, 1);
    setAnswers(newAnswers);

    const newCoppiedAnswerContent = [...coppiedAnswerContent];
    newCoppiedAnswerContent.splice(index, 1);
    setCoppiedAnswerContent(newCoppiedAnswerContent);

    const newAnswerEditorStates = [...answerEditorStates];
    newAnswerEditorStates.splice(index, 1);
    setAnswerEditorStates(newAnswerEditorStates);
  }

  const onReset = () => {
    setCoppiedQuestionContent("");
    setCoppiedAnswerContent([]);
    setAnswers([]);
    setQuestionEditorState("");
    setAnswerEditorStates([]);
    setQuesiton("");
    setSelectedInputIndex(-1);
    // setQuestionNumber(1);
    // setQuestionNumberPrefix("");
  };

  const addQuestion = async() => {
    const questionName = `${questionNumberPrefix}-${questionNumber}`;

    try{
      setLoading(true);

      if(questionNumberPrefix === "") {
        alert("Question name cannot be empty");
        return
      }

      // console.log(Number.isInteger(Number(questionNumber)))

      if(!Number.isInteger(Number(questionNumber))) {
        alert("Question number should be an integer");
        return
      }

      if(quesiton === "") {
        alert("Question cannot be empty");
        return
      }
      if(coppiedAnswerContent.length === 0) {
        alert("At least one answer is required");
        return
      }
      if(isEmpty(questionEditorState) || Object.keys(questionEditorState).length === 0) {
        alert("Question editor state cannot be empty");
        return
      }

      const mcqOptions = answers.map((answer, index) => ({
        answerText : answer,
        answerTextEditorState: answerEditorStates[index] || {},
        mark: index == 0 ? 1.0 : 0.0,
      }))

      const questionBody = {
                question: {
                    name : questionName,
                    questionText: quesiton,
                    questionTextEditorState : questionEditorState,
                    generalFeedback: "",
                    generalFeedbackEditorState : "",
                    defaultMark: 4.0,
                    questionType: { id: 1 },
                    // subjectTopics: allSubTopics,
                    subject: { id: subjectId_ },
                    isReviewAvailable: false,
                    status : "PENDING",
                },
                "singleChoice": true,
                "shuffleChoices": false,
                "numberOfChoices": mcqOptions.length,
                "multiChoiceOptions": mcqOptions
            }

            // console.log(questionBody)

            setQuestionView({
              open: true,
              question: questionBody,
            })
            // const response = await createMcqQuestion(subjectId_, questionBody);
            // const { data, status } = response;
            // if (status === 200) {
            //   onReset();
            //   setQuestionNumber(Number(questionNumber) + 1);

            // }

    }catch(e) {
      console.error("Error adding question", e);
    }finally {
      setLoading(false);
    }
  }

  const setNextQuestionNumber = () => {
    const currentQuestionNumber = Number(questionNumber);
    if(currentQuestionNumber < 9){
      const nextNumber = Number(questionNumber) + 1;
      setQuestionNumber('0' + nextNumber);
    }else{
      setQuestionNumber(Number(questionNumber) + 1);
    }
  }

  const onAfterOkay = async() => {
    let questionName = `${questionNumberPrefix}-${questionNumber}`;
    if(Number(questionNumber) < 10){
      questionName = `${questionNumberPrefix}-0${Number(questionNumber)}`;
    }

    try{
      setLoading(true);

      if(quesiton === "") {
        alert("Question cannot be empty");
        return
      }
      if(coppiedAnswerContent.length === 0) {
        alert("At least one answer is required");
        return
      }
      if(isEmpty(questionEditorState) || Object.keys(questionEditorState).length === 0) {
        alert("Question editor state cannot be empty");
        return
      }

      const mcqOptions = answers.map((answer, index) => ({
        answerText : answer,
        answerTextEditorState: answerEditorStates[index] || {},
        mark: index == 0 ? 1.0 : 0.0,
      }))

      const questionBody = {
                question: {
                    name : questionName,
                    questionText: quesiton,
                    questionTextEditorState : questionEditorState,
                    generalFeedback: "",
                    generalFeedbackEditorState : "",
                    defaultMark: 4.0,
                    questionType: { id: 1 },
                    // subjectTopics: allSubTopics,
                    subject: { id: subjectId_ },
                    isReviewAvailable: false,
                    status : "PENDING",
                },
                "singleChoice": true,
                "shuffleChoices": false,
                "numberOfChoices": mcqOptions.length,
                "multiChoiceOptions": mcqOptions
            }

            // console.log(questionBody)

            // setQuestionView({
            //   open: true,
            //   question: questionBody,
            // })
            const response = await createMcqQuestion(subjectId_, questionBody);
            const { data, status } = response;
            if (status === 200) {
              onReset();
              setNextQuestionNumber();
            }

    }catch(e) {
      console.error("Error adding question", e);
    }finally {
      setLoading(false);
      setQuestionView({ open: false, question: null });
    }
  }

  const answerContainerRef = useRef(null);

  return (
    <>
      <div
        ref={answerContainerRef}
        style={
          {
            // height: "300px",
          }
        }
      >
        
        <div
          style={{
            position: "fixed",
            bottom: "0px",
            zIndex: 1000,
            backgroundColor: "green",
            padding: "12px",
            // height: "100px",
          }}
        >
          <input type="file" onChange={handleFileUpload} />

          <button onClick={onSelectQuestion} style={{ marginTop: "1rem" }}>
            Select Question
          </button>
          <button onClick={onSelectAnswer} style={{ marginTop: "1rem" }}>
            Select Answer
          </button>
          <button onClick={onReset} style={{ marginTop: "1rem" }}>
            Reset
          </button>

          <TextField
            type="text"
            value={questionNumberPrefix}
            placeholder="Question name prefix"
            onChange={handleNamePrefixChange}
            style={{
              width: "150px",
              backgroundColor: "#f0f0f0",
            }}
          />

          <TextField
            type="text"
            value={questionNumber}
            placeholder="Number"
            onChange={handleNumberChange}
            style={{
              width: "100px",
              backgroundColor: "#f0f0f0",
            }}
          />

          <button onClick={addQuestion} style={{ marginTop: "1rem" }}>
            Add question
          </button>
        </div>

        <div
          id="docx-preview"
          style={{
            border: "1px solid #ccc",
            padding: "1rem",
            marginTop: "1rem",
            minHeight: "200px",
            cursor: "text",

            overflowY: "auto",
            height: "280px",
            backgroundColor: "#f9f9f9",
            zIndex: 100,
            position: "sticky",
            top: "0px",
          }}
          ref={inputRef}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        ></div>

        {/* {loading ? (
          <Box sx={{ width: "100%", top: "0px", position: "sticky" }}>
            <LinearProgress />
          </Box>
        ) : null} */}

        {/* <TextField
        type="text"
        value={quesiton}
        placeholder="Selected text will appear here"
        style={{
          marginTop: "1rem",
          width: "100%",
          backgroundColor: selectedInputIndex == -1 ? "#ffffff" : null,
        }}
        // readOnly
        fullWidth
        multiline
        rows={10}
        onChange={(e) => setQuesiton(e.target.value)}
        onFocus={() => setSelectedInputIndex(-1)}
        inputRef={inputRef}
      /> */}

        <div
          style={{
            height: "10%",
            width: "100%",
            overflowY: "auto",
            marginTop: "1rem",
            border: "1px solid #ccc",
            padding: "1rem",
            bottom: "100px",
            marginBottom: "100px",
          }}
        >
          <TextEditorWithTitle
            title={"Question"}
            setLoading={setLoading}
            loading={loading}
            editorState={{}}
            html={coppiedQuestionContent}
            onChangeEditorState={setQuestionEditorState}
            onChangeHtml={(html) => onChangeHtml(html, -1)}
            currentHtml={quesiton}
            // key={currentKey}
          />
          {/* <PlaygroundApp
          html={coppiedQuestionContent}
          editorState={{}}
          onChangeEditorState={setQuestionEditorState}
          onChangeHtml={(html) => onChangeHtml(html, -1)}
          i={-1}
        /> */}

          {coppiedAnswerContent.map((answer, index) => (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                marginTop: "1rem",
              }}
            >
              {/* <div key={index} style={{ marginTop: "1rem", flex: 1 }}> */}
              {/* <PlaygroundApp
                html={answer}
                editorState={{}}
                onChangeEditorState={(state) =>
                  handleChangeAnswerEditorState(state, index)
                }
                onChangeHtml={(html) => onChangeHtml(html, index)}
                i={index}
              /> */}
              <TextEditorWithTitle
                title={`Answer ${index + 1}`}
                //   onChange={(html, index) => onChangeContent(html, index, 'answerText')}
                setLoading={setLoading}
                loading={loading}
                html={answer}
                editorState={{}}
                onChangeEditorState={(state) =>
                  handleChangeAnswerEditorState(state, index)
                }
                onChangeHtml={(html) => onChangeHtml(html, index)}
                currentHtml={answers[index] || ""}
                //    key={ (i + 1) * 100}
                index={index}
                key={index}
              />
              {/* </div> */}
              <div
                style={{
                  width: "100px",
                  backgroundColor: "#c91f1fff",
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    handleDeleteAnswer(index);
                  }}
                >
                  Delete
                </Button>
              </div>
            </Box>
          ))}
        </div>

      </div>

      <QuestionViewPopup
        questionView ={questionView}
        setQuestionView={setQuestionView}
        justView={true}
        onAfterOkay = {onAfterOkay}
        onAfterCancel={() => setQuestionView({ open: false, question: null })}
        />

</>
    
  );
}

export default WordEditor